export default __webpack_public_path__ + "static/media/info-icon.867b609d.svg";